import request from "@/utils/request.js"

// 排课列表
export const listLesson = (pageData, formData) => {
    return request.get(`/lesson/${pageData.page}/${pageData.pageSize}`, {params: formData})
}

// 学员列表
export const listLessonStudent = (pageData, formData) => {
    return request.get(`/lesson/student/${pageData.page}/${pageData.pageSize}`, {params: formData})
}

// 新增排课
export const addLesson = (updateData) => {
    return request.post(`/lesson`, updateData)
}

// 修改排课
export const editLesson = (updateData) => {
    return request.put(`/lesson/${updateData.lessonId}`, updateData)
}

// 排课详情
export const getLesson = (id) => {
    return request.get(`/lesson/${id}`)
}